<!--
  ~ Copyright (c) GM Global Technology Operations LLC. All rights reserved.
  ~ This information is confidential and proprietary to GM Global Technology
  ~ Operations LLC and may not be used, modified, copied or distributed.
  -->


<fab-loading-spinner color="primary" *ngIf="showSpinner"></fab-loading-spinner>
<div class="d-flex flex-column gap-8 w-100">
  <div id="header-container" class="pb-2">
    <h3 id="header-text">Engine Transmission Detail</h3>
    <button mat-flat-button color="primary"
            (click)="getReport()">
      Run Report
    </button>
  </div>
</div>
